import { useQuery } from "@tanstack/react-query";
import api from "../axios-client";

export const useGetFleetStats = () => {
    return useQuery({
        queryKey: ["fleet", "stats"],
        queryFn: async () => {
            const response = await api.get("/api/v1/fleet/stats");
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 2,
        refetchInterval: 1000 * 60 * 2,
    });
};

export const useGetFleetOverview = () => {
    return useQuery({
        queryKey: ["fleet", "dashboard", "overview"],
        queryFn: async () => {
            const response = await api.get("/api/v1/fleet/dashboard/overview");
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 2,
        refetchInterval: 1000 * 60 * 2,
    });
};

export const useGetFleetProductivity = (period: string) => {
    return useQuery({
        queryKey: ["fleet", "dashboard", "productivity", period],
        queryFn: async () => {
            const response = await api.get(`/api/v1/fleet/dashboard/productivity?period=${period}`);
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 5,
        refetchInterval: 1000 * 60 * 5,
    });
};

export const useGetFleetErrors = (period: string) => {
    return useQuery({
        queryKey: ["fleet", "dashboard", "errors", period],
        queryFn: async () => {
            const response = await api.get(`/api/v1/fleet/dashboard/errors?period=${period}`);
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 5,
        refetchInterval: 1000 * 60 * 5,
    });
};
